import { render, staticRenderFns } from "./GraphDetail51.vue?vue&type=template&id=040b06a6&scoped=true"
import script from "./GraphDetail51.vue?vue&type=script&lang=js"
export * from "./GraphDetail51.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b06a6",
  null
  
)

export default component.exports